import { Box } from '@chakra-ui/react';
import { TextMedium, TextRegular } from 'UiKit/typography';

import styles from './styles.module.css';

const getTableList = (t) => [
  {
    name: <TextRegular className={styles['table-column__title']}>{t('promo_detail.product')}</TextRegular>,
    key: 'product',
    width: '70%',
    position: 'left',
    component: ({ value }) => {
      return (
        <Box className={`${styles['table-cell__product--container']}`}>
          <TextRegular className={`${styles['table-cell__product--info--text']}`}>
            {value?.sku} | {value?.brand}
          </TextRegular>
          <TextMedium className={`${styles['table-cell__name--text']}`}>{value?.name}</TextMedium>
          <Box className={`${styles['table-cell__product--price--container']}`}>
            <TextMedium className={`${styles['table-cell__promo--price--text']}`}>{value?.promoPrice}</TextMedium>
            <TextRegular className={`${styles['table-cell__normal--price--text']}`}>
              | {value?.normalPrice} | {value?.discountPercentage}
            </TextRegular>
          </Box>
        </Box>
      );
    },
  },
  {
    name: <TextRegular className={styles['table-column__title']}>{t('promo_detail.stock_left')}</TextRegular>,
    key: 'remainingStock',
    width: '15%',
    position: 'left',
    component: ({ value }) => {
      return <TextRegular className={styles['table-cell__promo--stock--text']}>{value}</TextRegular>;
    },
  },
  {
    name: <TextRegular className={styles['table-column__title']}>{t('promo_detail.allocation')}</TextRegular>,
    key: 'allocatedStock',
    width: '15%',
    position: 'left',
    component: ({ value }) => {
      return <TextRegular className={styles['table-cell__promo--stock--text']}>{value}</TextRegular>;
    },
  },
];

export default getTableList;
